export default "__VITE_ASSET__DKTH84fI__"